import { PcApiResponse } from '@/api/pc-api/types';
import { StatType } from '@/api/pc-api/v1/{authInfoId}/service-stat/type';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export enum RequestRankingOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

type Args = {
  rankingOrder: RequestRankingOrder;
  statType: StatType;
  statDate: string;
  size: number;
};

export type RequestRanking = {
  id: string;
  companyName: string;
  requestCount: number;
  rank: number;
  rankDiff?: number;
};

/** 문서 발송 혹은 인증 요청 순위 조회 */
export const getRequestRanking = (args: Args) => {
  return api<PcApiResponse<RequestRanking[]>>('get', `/pc-api/v1/${PREFIX_PATH}/service-stat/request-ranking`, args);
};
